<div class="box-theme">
    <div class="head">
        <div class="header">
            <div class="ico">
                <img src="./assets/img/icon-10.png" alt="Suscripción de boleta electrónica">
            </div>
        </div>
        <div class="body">
            <h1>Suscripción de boleta electrónica</h1>
            <p>Cuida el medio ambiente cambiándote aquí a la boleta electrónica de Metrogas, <br> la forma más práctica, cómoda y segura de recibir tu cuenta de gas natural. <br> *Aplica sólo para tipo de documento boleta.</p>
        </div>
    </div>
    <div class="body">
        <div class="counter-pasos">
            <ul class="stepper-lineas">
                <li>
                    <span class="linea-current"></span>
                </li>
                <li></li>
            </ul>
            <ul class="stepper">
                <li [ngClass]="{ 'numActive':pasos[0]['P2'].CurrentNum === true }">
                    <p>1</p>
                </li>
                <li [ngClass]="{ 'numActive':pasos[0]['P3'].CurrentNum === true }">
                    <p>2</p>
                </li>
            </ul>
        </div>
        <!-- PASO NUMERO 2 -->
        <div class="paso-2" *ngIf="pasos[0]['P2'].I">
            <div class="header">
                <h2>
                    Suscripción de boleta electrónica
                </h2>
            </div>
            <div class="body">
                <form [formGroup]="formData">
                    <div class="form">
                        <div class="head">
                            <h2>
                                Identificación del solicitante
                            </h2>
                            <p class="txt-orange">
                                (**datos obligatorios)
                            </p>
                        </div>
                        <div class="body">
                            <ul>
                                <li>
                                    <div class="box-campo-form">
                                        <input type="text" placeholder="**Nombre y apellido" formControlName="nombre" [maxLength]="200" [ngClass]="{ 'is-invalid': submitted && f.nombre.errors }" />
                                        <div class="error">
                                            <div *ngIf="submitted && f.nombre.errors">
                                                <p *ngIf="f.nombre.errors.required">
                                                    dato obligatorio
                                                </p>
                                                <p *ngIf="f.nombre.errors.pattern">
                                                    nombre inválido
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="box-campo-form">
                                        <input type="text" placeholder="**Cédula de identidad" formControlName="rut" [maxLength]="12" [ngClass]="{ 'is-invalid': submitted && f.rut.errors }" (blur)="formatearRut($event)" />
                                        <div class="error">
                                            <div *ngIf="submitted && f.rut.errors">
                                                <p *ngIf="f.rut.errors.required">
                                                    dato obligatorio
                                                </p>
                                                <p *ngIf="f.rut.errors.maxlength || f.rut.errors.minlength || f.rut.errors?.rutValid">
                                                    rut inválido
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="box-campo-form">
                                        <input type="text" placeholder="Teléfono de contacto" formControlName="telefono" [maxLength]="9" [ngClass]="{ 'is-invalid': submitted && f.telefono.errors }" />
                                        <div class="error">
                                            <div *ngIf="submitted && f.telefono.errors">
                                                <p *ngIf="f.telefono.errors.required">
                                                    dato obligatorio
                                                </p>
                                                <p *ngIf="f.telefono.errors.maxlength || f.telefono.errors.pattern">
                                                    teléfono inválido
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="box-campo-form">
                                        <input type="email" placeholder="**Correo electrónico" formControlName="email" [maxLength]="200" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                                        <div class="error">
                                            <div *ngIf="submitted && f.email.errors">
                                                <p *ngIf="f.email.errors.required">
                                                    dato obligatorio
                                                </p>
                                                <p *ngIf="f.email.errors.email || f.email.errors.maxlength">
                                                    email inválido
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="form">
                        <div class="head">
                            <h2>
                                Datos del domicilio
                            </h2>
                        </div>
                        <div class="body">
                            <ul>
                                <li>
                                    <div class="box-campo-form">
                                        <div class="cont-numero-cliente">
                                            <input type="text" placeholder="**Número de cliente" [maxLength]="9" formControlName="nCliente" [ngClass]="{ 'is-invalid': submitted && f.nCliente.errors }" />
                                            <div class="error" *ngIf="formData.get('nCliente')?.errors?.numClienteValid || formData.get('nCliente')?.errors?.numClienteExist">
                                                <p> número de cliente inválido</p>
                                            </div>
                                            <div class="div-numero-cliente">
                                                <a style="cursor: pointer;" (click)="mostrarNumeroCliente()">
                                                    <img class="info-numero-cliente" src="./assets/img/info-icon.png" alt="Información número de cliente">
                                                </a>
                                            </div>
                                            <div class="error">
                                                <div *ngIf="submitted && f.nCliente.errors">
                                                    <p *ngIf="f.nCliente.errors.required">
                                                        dato obligatorio
                                                    </p>
                                                    <p *ngIf="f.nCliente.errors.maxlength || f.nCliente.errors.pattern || f.nCliente.errors.numClienteValid || f.nCliente.errors.numClienteExist">
                                                        número de cliente inválido
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="box-campo-form">
                                        <input type="text" placeholder="**Dirección" formControlName="direccion" [maxLength]="200" [ngClass]="{ 'is-invalid': submitted && f.direccion.errors }" />
                                        <div class="error">
                                            <div *ngIf="submitted && f.direccion.errors">
                                                <p *ngIf="f.direccion.errors.required">
                                                    dato obligatorio
                                                </p>
                                                <p *ngIf="f.direccion.errors.pattern">
                                                    dirección inválida
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="box-campo-form">
                                        <div class="ng-autocomplete">
                                            <ng-select #region [items]="dataRegion" [selectOnTab]="true" bindValue="id_region" bindLabel="nombre_region" placeholder="**Región" formControlName="region" notFoundText="Región no encontrada">
                                            </ng-select>
                                        </div>
                                        <div class="error">
                                            <div *ngIf="submitted && f.region.errors">
                                                <p *ngIf="f.region.errors.required">
                                                    dato obligatorio
                                                </p>
                                                <p *ngIf="f.region.errors.pattern">
                                                    región inválida
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div class="box-campo-form">
                                        <input type="text" placeholder="**Comuna" formControlName="comuna" [maxLength]="200" [ngClass]="{ 'is-invalid': submitted && f.comuna.errors }" />
                                        <div class="error">
                                            <div *ngIf="submitted && f.comuna.errors">
                                                <p *ngIf="f.comuna.errors.required">
                                                    dato obligatorio
                                                </p>
                                                <p *ngIf="f.comuna.errors.pattern">
                                                    comuna inválida
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="form">
                        <div class="terminos-condiciones">
                            <ul>
                                <li>
                                    <div class="box-campo-form">
                                        <label class="container-checkbox">
                                            <input type="checkbox" formControlName="terminos" name="terminos" value="terminos" required>
                                            <span class="checkmark"></span>
                                        </label>
                                        <p>
                                            <a style="cursor: pointer;" (click)="mostrarTerminos($event)">He leído y aceptado la política de privacidad.</a>
                                            <span class="error">
                                                <span *ngIf="submitted && f.terminos.errors && f.terminos.errors.required">
                                                    <br>Check requerido
                                                </span>
                                            </span>
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="footer">
                            <div class="callToAcction">
                                <input type="button" value="VOLVER" class="btn btn-volver" [routerLink]="['/home']">
                                <input type="button" name="GUARDAR" value="GUARDAR" 
                                    class="btn btn-continuar" 
                                    (click)="onSubmit()" 
                                    [disabled]="isGuardarDisabled"
                                    [ngClass]="{'btn-disabled': isGuardarDisabled}">
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="paso-3" *ngIf="pasos[0]['P3'].I">
            <div class="body">
                <app-suscripcion-boleta-satisfactoria [solicitud]="respuesta.NumAviso" [codigo]="respuesta.Mensajes.item[0].CodMensaje" [mensaje]="respuesta.Mensajes.item[0].TxtMensajes" [plazo]="plazo"></app-suscripcion-boleta-satisfactoria>
            </div>

        </div>
    </div>
</div>

<div class="modal-suscripcion">
    <div class="punto-informacion">
        <ul>
            <li>
                <div class="contenido-terminos">
                    <h3>Condiciones de uso</h3>
                    <p>
                        Autorizo a la empresa Metrogas, RUT 96.722.460-K, para que me envíe los documentos tributarios electrónicos a través del correo electrónico registrado.
                    </p>
                    <p>
                        La presente autorización estará vigente desde ahora y hasta el momento en que sea revocada por mí, en cualquier tiempo y sin necesidad de expresión de causa.
                    </p>
                    <!--BOTON PARA CERRAR EL MODAL, ESCONDIDO, SIMPLEMENTE DESCOMENTANDO EL BOTON SE ACTIVA-->
                    <div class="callToAcction">
                        <input type="button" value="Aceptar" class="btn-cerrar-modal center" onclick="$('.basicLightbox').hide();">
                    </div>
                </div>
            </li>
        </ul>
    </div>
</div>


<div class="modal-requerido">
    <div class="punto-informacion">
        <h3>Debes completar todos los datos solicitados para continuar</h3>
        <div class="callToAcction">
            <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
        </div>
    </div>
</div>

<div class="modal-error">
    <div class="punto-informacion">
        <h3>Ha ocurrido un error, vuelva a intentarlo más tarde</h3>
        <div class="callToAcction">
            <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
        </div>
    </div>
</div>

<div class="modal-error-cliente">
    <div class="punto-informacion">
        <h3>El número de cliente no existe o es erróneo</h3>
        <div class="callToAcction">
            <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
        </div>
    </div>
</div>

<div class="modal-numero-cliente">
    <div class="punto-informacion">
        <!--<img class='img-numero-cliente' src='./assets/img/numero_cliente.png'>-->
        <img class='img-numero-cliente' src='./assets/img/conoce-numero-cliente.jpg' alt="Conoce tu número de cliente">
        <p class="texto-numero-cliente">
            Si no tienes tu número de cliente obtenlo ingresando tu dirección en metrogas.cl
            <!--El número de cliente aparece en la parte superior de su boleta de gas.-->
        </p>
        <div class="callToAcction">
            <input type="button" value="CONTINUAR" class="btn btn-continuar center" onclick="$('.basicLightbox').hide();">
        </div>
    </div>
</div>

<ngx-spinner>
    <p style="font-size: 20px; color: white; font-family: 'Khand', sans-serif;">{{spinnerMsg}}</p>
</ngx-spinner>
